import axiosInstance from '../axiosInstance';

const BASE_URL = '/report/service-orders';

export const fetchServiceOrderExecutiveDashboard = async (params = {}) => {
    const { data } = await axiosInstance.get(`${BASE_URL}/executive-dashboard`, {
        params,
    });

    return data;
};

export const fetchServiceOrderSummary = async (params = {}) => {
    const { data } = await axiosInstance.get(`${BASE_URL}/summary`, {
        params,
    });

    return data;
};

export const fetchServiceOrderRiskAlerts = async (params = {}) => {
    const { data } = await axiosInstance.get(`${BASE_URL}/risk-alerts`, {
        params,
    });

    return data;
};

export const fetchServiceOrdersByStatus = async (params = {}) => {
    const { data } = await axiosInstance.get(`${BASE_URL}/by-status`, {
        params,
    });

    return data;
};

export const fetchServiceOrdersByProject = async (params = {}) => {
    const { data } = await axiosInstance.get(`${BASE_URL}/by-project`, {
        params,
    });

    return data;
};

export const fetchServiceOrderMonthly = async (params = {}) => {
    const { data } = await axiosInstance.get(`${BASE_URL}/monthly`, {
        params,
    });

    return data;
};

export const fetchServiceOrderPendingValuation = async (params = {}) => {
    const { data } = await axiosInstance.get(`${BASE_URL}/pending-valuation`, {
        params,
    });

    return data;
};

export const fetchServiceOrdersDetailByStatus = async (status, params = {}) => {
    const { data } = await axiosInstance.get(
        `${BASE_URL}/by-status/${status}/orders`,
        { params }
    );

    return data;
};